import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  color?: string;
  style?: React.CSSProperties;
}

export default function Logo({ size = 'md', className = '', style }: LogoProps) {
  const sizes = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-14 h-14',
    xl: 'w-20 h-20',
  };

  return (
    <img
      src="/Kerkplanner_logo.png"
      alt="Kerkplanner"
      className={`${sizes[size]} object-contain ${className}`}
      style={style}
    />
  );
}
